document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-abel-finishes]').forEach(picker => {
    picker.querySelectorAll('a').forEach(link => {
      const target = new URL(link.href, window.location.origin);
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview) target.searchParams.set('preview_theme_id', preview);
      link.href = target.href;
    });
  });
});
